import { DetailDeleteHeaderAction } from '@/features/shared/components/DetailDeleteHeaderAction';
import { EntityTagsMetadataSection } from '@/features/shared/components/EntityTagsMetadataSection';
import { DetailPageTemplate, DetailTitlePrefix } from '@/ui/composites/scaffolds';
import { Text } from '@/ui/primitives/Text';
import type { ReactElement } from 'react';

type ReleaseDetailContentProps = {
  title: string;
  tags: string[] | undefined;
  onDelete?: () => Promise<void> | void;
  deleteLoading?: boolean;
};

export const ReleaseDetailContent = ({
  title,
  tags,
  onDelete,
  deleteLoading = false,
}: ReleaseDetailContentProps): ReactElement => (
  <DetailPageTemplate
    title={
      <Text role="sectionTitle" component="h1">
        <DetailTitlePrefix label="Release" />
        {title}
      </Text>
    }
    headerActions={
      <DetailDeleteHeaderAction
        onDelete={onDelete}
        deleteLoading={deleteLoading}
        dialogTitle="Delete Release"
        dialogDescription="This will permanently delete the release. This action cannot be undone."
        confirmLabel="Delete Release"
      />
    }
    metadata={<EntityTagsMetadataSection tags={tags} />}
  />
);
